import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { HealthcareProfessionalsApi } from '../../../apis/HealthcareProfessionalsApi/HealthcareProfessionalsApi.ts';
import { HealthcareProfessional } from '../HealthcareProfessional.ts';

export function useDeleteHcpMutations() {
    const queryClient = useQueryClient();

    return useMutation<number, AppMedError, string>({
        mutationKey: [QueryKeys.healthcareProfessionals],
        mutationFn: async (entityId: string) => {
            if (!entityId) 
                return 0;
            
            await HealthcareProfessionalsApi.deleteHealthcareProfessionalyId(entityId);

            queryClient.setQueryData<HealthcareProfessional[]>([QueryKeys.healthcareProfessionals], (prev) => {
                return prev ? prev.filter((el) => el.id !== Number(entityId)) : [];
            });

            return Number(entityId);
        },
        onError: (error) => {
            console.error('Erreur dans la mutation :', error);
        },
    });
}
